import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { CommonService } from './services/common.service';
import { Facebook } from '@ionic-native/facebook/ngx';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'n2ui';
  constructor(public auth:AuthService,public common:CommonService,public fb: Facebook){

  }

  ngOnInit(){
    // this.fb.logEvent("Launch",{name:"hello"}).then(res=>{
    //   //console.log(res)
    //   //console.log("fired1")
    // }).catch(err=>{
    //   //console.log(err)
    // })


/*     let param={}
    param['Email']="xyz@alphafortress.com"
    this.fb.logEvent(this.fb.EVENTS.EVENT_NAME_COMPLETED_REGISTRATION,"porwaljayneet97@gmail.com").then(res=>{
      //console.log(res)
      //console.log("fired again")
    }).catch(err=>{
      //console.log(err)
    }) */

    /* this.fb.logEvent(this.fb.EVENTS.EVENT_NAME_COMPLETED_REGISTRATION).then(res=>{
      //console.log(res)
      //console.log("firejhujghud again")
    }).catch(err=>{
      //console.log(err)
    }) */



    //this.fb.logEvent(this.fb.EVENTS.EVENT_NAME_RATED)

  }
}
